import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { GRAPHQL_ORIGIN } from './config';

/**
 * Use a federated graphql service uri provided as an environment variable or default to the
 * mock graphql api url -> localhost:10002/graphql.
 */

const client = () => {
  const uri = `${GRAPHQL_ORIGIN}/graphql/`;
  const credentials = { credentials: 'include' };
  const link = createHttpLink({
    uri,
    ...credentials,
  });

  const apolloClient = new ApolloClient({
    cache: new InMemoryCache(),
    link,
  });

  return apolloClient;
};

export default client;
